module.exports = __webpack_public_path__ + "static/img/menu.04cb5dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu.png
// module id = F3CK
// module chunks = 1